import { render, staticRenderFns } from "./ContactUs2.vue?vue&type=template&id=134c4ea2"
import script from "./ContactUs2.vue?vue&type=script&lang=js"
export * from "./ContactUs2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports